export default __webpack_public_path__ + "static/media/8608.9cc31d33.png";